import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PeopleIcon from "@mui/icons-material/People";
import { Drawer, IconButton, Toolbar } from "@mui/material";
import { FC, useMemo } from "react";
import { CurrentUser } from "../layout/header/current-user/current-user";
import { Sidebar } from "../sidebar/sidebar";
import { classes } from "./mobile-drawer.styles";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import { useLogout } from "../../hooks/useLogout";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const menuItems = [
  {
    label: "Users list",
    link: "/admin-portal/users",
    icon: PeopleIcon,
  },
  {
    label: "Active Tags",
    link: "/admin-portal/active-tags",
    icon: LocalOfferIcon,
  },
];

export const MobileDrawer: FC<Props> = ({ isOpen, onClose }) => {
  const { handleLogout } = useLogout();

  const logoutSection = useMemo(
    () => [
      {
        label: "Settings",
        link: "user",
        icon: SettingsIcon,
      },
      {
        label: "Logout",
        icon: LogoutIcon,
        action: handleLogout,
      },
    ],
    [handleLogout]
  );

  return (
    <Drawer sx={classes.drawer} open={isOpen} onClose={onClose}>
      <Toolbar sx={classes.toolbar}>
        <IconButton
          sx={classes.close}
          color="primary"
          edge="end"
          onClick={onClose}
        >
          <ArrowBackIcon />
        </IconButton>
        <CurrentUser />
      </Toolbar>

      <Sidebar menuItems={menuItems} onItemClick={onClose} />

      <Sidebar menuItems={logoutSection} onItemClick={onClose} />
    </Drawer>
  );
};
